import React from "react";

export default () => (
  <svg
    className="fill-current inline"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    transform="rotate(180 0 0)"
  >
    <polygon id="path-1" points="7 6 7 14 14 10" />
  </svg>
);
